<template>
  <span>
    <slot
      :onClick="onClick"
      :isResolved="isResolved"
      :disabled="submit"
    />
  </span>
</template>

<script>
import axios from "axios";
import {ChatStatusChat, ChatStatusResolved} from "../../../services/chat/const";

export default {
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tForm: 'chat.manager',
      submit: false,
      ChatStatusChat,
      ChatStatusResolved,
    };
  },
  computed: {
    isResolved() {
      return this.room.status === ChatStatusResolved
    },
  },
  watch: {
    submit(submit) {
      this.$emit('update:submit', submit);
    },
  },
  methods: {
    onClick() {
      const {id} = this.room;
      const status = this.isResolved ? ChatStatusChat : ChatStatusResolved;

      this.submit = true;
      axios
        .put(`/chats/api/v1/chats/${id}/status`, {}, {params: {status}})
        .then(() => this.$store.commit('rooms/SET_ROOMS', [{...this.room, status}]))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
